module.exports = __webpack_public_path__ + "img/comment set.503ded11.svg";